import { ProjectCard } from "./ProjectCard"
import styles from "./Styles/ProjectsSection.module.css"
import { SiReact } from "react-icons/si"
import { SiJavascript } from "react-icons/si"
import { SiHtml5 } from "react-icons/si"
import { SiCss3 } from "react-icons/si"

import Fade from "react-reveal/Fade"
const projects = [{
    name: "Buffer.com clone",
    img: "/ecotone.jpg",
    link: "https://ecotone77.netlify.app/",
    git: "https://github.com/gShubham7/Buffer-clone",
    about:"It is a Social Media Post Scheduler web application where user can create edit and delete the posts on different channels.Create using HTML,CSS,JavaScript and react, MongoDB, Express, Nodejs",
    stacks: [
      <SiJavascript className={styles.stackIcon} />,
      <SiHtml5 className={styles.stackIcon} />,
      <SiCss3 className={styles.stackIcon} />,
      <SiReact className={styles.stackIcon} />,
    ],
  },
  
  {
    name: "Bonsai clone",
    img: "/bontime.jpg",
    link: "https://bontime.vercel.app/",
    git: "https://github.com/ajay329/BONSAI-CLONE",
    about:
      "Bonsai is building the global operating system for freelance work. Create using HTML,CSS,JavaScript and react, MongoDB, Express, Nodejs",
    stacks: [ <SiJavascript className={styles.stackIcon} />,
      <SiHtml5 className={styles.stackIcon} />,
      <SiCss3 className={styles.stackIcon} />,
      <SiReact className={styles.stackIcon} />,
    ],
  },

  {
    name: "Himalaya clone",
    img: "/himalaya.jpg",
    link: "https://himalayausa1.netlify.app/",
    git: "https://github.com/saurabhKJ7/HIMALAYAUSA-CLONE",
    about:
      "An e-commerce website of multinational pharmaceutical  products .Create using HTML,CSS and JavaScript.",
    stacks: [
      <SiJavascript className={styles.stackIcon} />,
      <SiHtml5 className={styles.stackIcon} />,
      <SiCss3 className={styles.stackIcon} />,
    ],
  },
  {
    name: "Ketto clone",
    img: "/ketto.jpg",
    link: "https://ketto-silk.vercel.app/",
    git: "https://github.com/ajay329/frightened-van-975",
    about:
      "A solo project of Ketto clone. It is india's best medical crowdfunding Platform. Create using HTML,CSS,JavaScript and react",
    stacks: [
      <SiJavascript className={styles.stackIcon} />,
      <SiHtml5 className={styles.stackIcon} />,
      <SiCss3 className={styles.stackIcon} />,
      <SiReact className={styles.stackIcon} />,
    ],
  },

  
];
export function ProjectsSection() {
  return (
    <div className={styles.projectsSectionCont} id="projects">
      <Fade bottom>
        <p>Projects</p>
      </Fade>
      <div className={styles.projectGrid}>
        {projects.map((project) => (
          <Fade bottom>
            <ProjectCard {...project} />
          </Fade>
        ))}
      </div>
    </div>
  )
}
